<template>
  <div
    class="doctor-list-main-wrapper cbg-white-container input-container theme--light v-card p-16 border-card"
  >
    <CRow v-if="!showDoctorProfile">
      <CCol sm="12">
        <CRow>
          <CCol sm="3">
            <div class="common-search">
              <CInput
                label="Search by Name"
                v-model="search"
                placeholder="Name"
              />
              <div
                v-if="search !== ''"
                class="cross-svg position-absolute"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
            </div>
          </CCol>
          <CCol sm="3">
            <div class="position-relative">
              <CSelect
                label="Per page"
                @update:value="udpateRecordPerPage"
                :options="perPageOptions"
              />
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="v-icon mdi mdi-menu-down theme--light position-absolute"
                ></i>
              </span>
            </div>
          </CCol>
          <CCol sm="3">
            <div class="position-relative">
              <CSelect
                label="Filter by status"
                @update:value="udpateStatus"
                :options="statusOptions"
                v-model="status"
              />
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="v-icon mdi mdi-menu-down theme--light position-absolute"
                ></i>
              </span>
            </div>
          </CCol>
          <CCol sm="3">
            <div>
              <v-btn
                @click="downloadCsv()"
                class="btn btn-primary export-doctor-list"
                :disabled="exportLoading"
                >{{ exportLoading ? "Exporting..." : "Export" }}</v-btn
              >
            </div>
          </CCol>
        </CRow>
      </CCol>
      <CCol sm="12">
        <!-- <CTableWrapper fixed bordered caption="Bordered Table" /> -->

        <div class="overflow-auto">
          <table class="table userlistTable table-width small-table-width">
            <thead>
              <tr class="table-success">
                <th scope="col">Name</th>
                <th scope="col">City</th>
                <th scope="col">Status</th>
                <th scope="col">Requested on</th>
                <th scope="col" class="small-min-width-120">Verified by</th>
                <th scope="col" class="small-min-width-120">Doctor fee</th>
                <th class="text-center" scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="doctor in doctors" :key="doctor._id">
                <th class="text-capitalize">
                  {{ doctor.doctor_id.full_name }}
                  <br />
                  <small class="text-muted">{{
                    doctor.doctor_id.highest_qualification_to_display
                  }}</small>
                  <span
                    v-if="
                      doctor.doctor_id.highest_qualification &&
                        doctor.doctor_id.highest_qualification.length > 0
                    "
                    class="d-block text-success font-weight-bold cursor pt-1"
                    @click="
                      setHighestQualifications(
                        doctor.doctor_id.highest_qualification.length > 0
                          ? doctor.doctor_id.highest_qualification
                          : []
                      )
                    "
                  >
                    +
                    {{ doctor.doctor_id.highest_qualification.length }}
                    More</span
                  >
                </th>
                <td>
                  {{
                    doctor &&
                    doctor.doctor_id &&
                    doctor.doctor_id.address &&
                    doctor.doctor_id.address.current_address &&
                    doctor.doctor_id.address.current_address.city
                      ? doctor.doctor_id.address.current_address.city
                      : "N/A"
                  }}
                </td>
                <td>
                  <span v-if="doctor.current_document_status == 'PENDING'">
                    <span class="badge badge-warning">Pending</span>
                    <InfoIconSVG
                      v-if="checkRequestWasRejected(doctor.histories)"
                      v-c-tooltip.hover.click="
                        'This request was previously rejected. View log to see more details.'
                      "
                      class="info-icon iconwidth ml-3"
                    />
                  </span>
                  <span
                    class="badge badge-success"
                    v-else-if="doctor.current_document_status == 'APPROVED'"
                    >Approved</span
                  >
                  <span
                    class="badge badge-danger"
                    v-else-if="doctor.current_document_status == 'NOT_UPLOADED'"
                    >Not Uploaded</span
                  >
                  <span class="badge badge-danger" v-else>Rejected</span>
                </td>
                <td>{{ moment(doctor.createdAt) }}</td>
                <td>
                  <span
                    v-if="
                      doctor.current_document_status == 'PENDING' ||
                        doctor.current_document_status == 'NOT_UPLOADED'
                    "
                    >N/A</span
                  >
                  <span
                    v-else-if="doctor.current_document_status == 'APPROVED'"
                  >
                    {{
                      `${
                        doctor.approved_details.aprroved_by_admin
                          ? doctor.approved_details.aprroved_by_admin.first_name
                          : ""
                      } ${
                        doctor.approved_details.aprroved_by_admin
                          ? doctor.approved_details.aprroved_by_admin.last_name
                          : ""
                      }`
                    }}
                    <br />
                    <small class="text-muted">{{
                      moment(doctor.approved_details.approved_on)
                    }}</small>
                  </span>
                  <span v-else-if="doctor.current_document_status == 'REJECT'">
                    {{
                      doctor.rejected_details.rejected_by_admin
                        ? `${doctor.rejected_details.rejected_by_admin.first_name} ${doctor.rejected_details.rejected_by_admin.last_name}`
                        : ""
                    }}
                    <br />
                    <small class="text-muted">{{
                      moment(doctor.rejected_details.rejected_on)
                    }}</small>
                  </span>
                </td>
                <td>
                  {{ (doctor && doctor.minimum_fee_object && doctor.minimum_fee_object.first_fee && doctor.minimum_fee_object.follow_up_fee)
                   ? `${doctor.minimum_fee_object.first_fee} - ${doctor.minimum_fee_object.follow_up_fee}`
                    : ((doctor && doctor.minimum_fee_object && doctor.minimum_fee_object.first_fee && !doctor.minimum_fee_object.follow_up_fee)
                        ? `${doctor.minimum_fee_object.first_fee}`
                         : '-')}}
                </td>
                <td>
                  <div class="d-flex justify-content-end pr-8 small-table-padding">
                    <div
                      v-if="!(doctor.current_document_status == 'NOT_UPLOADED')"
                      class="my-3 mr-2"
                    >
                      <CButton
                        class="text-uppercase"
                        block
                        variant="outline"
                        color="success"
                        @click="$refs.DoctorLogModal.viewModal(doctor)"
                        v-if="
                          permissions.includes(
                            'CAN_VIEW_HISTORY_DOCTOR_APPROVAL'
                          )
                        "
                        :disabled="
                          doctor &&
                            doctor.histories &&
                            doctor.histories.length == 1
                        "
                        >View Log</CButton
                      >
                    </div>
                    <div class="my-3 mb-xl-0">
                      <CButton
                        :disabled="!doctor.registration_proof_image_url"
                        block
                        variant="outline"
                        color="success"
                        @click="verifyDoctor(doctor)"
                        v-if="
                          doctor.current_document_status == 'APPROVED' &&
                            permissions.includes(
                              'CAN_VIEW_DOCUMENT_DOCTOR_APPROVAL'
                            )
                        "
                        >View</CButton
                      >
                      <CButton
                        class="text-uppercase"
                        :disabled="!doctor.registration_proof_image_url"
                        block
                        variant="outline"
                        color="success"
                        @click="verifyDoctor(doctor)"
                        v-else-if="
                          doctor.current_document_status == 'PENDING' &&
                            permissions.includes(
                              'CAN_APPROVE_REJECT_DOCTOR_APPROVAL'
                            )
                        "
                        >Verify</CButton
                      >
                      <CButton
                        block
                        variant="outline"
                        color="danger"
                        @click="verifyDoctor(doctor)"
                        v-else-if="
                          doctor.current_document_status == 'NOT_UPLOADED' &&
                            permissions.includes(
                              'CAN_APPROVE_REJECT_DOCTOR_APPROVAL'
                            )
                        "
                        >Reject</CButton
                      >
                      <CButton
                        block
                        variant="outline"
                        color="danger"
                        @click="verifyDoctor(doctor)"
                        v-else-if="
                          doctor.current_document_status == 'REJECT' &&
                            permissions.includes(
                              'CAN_VIEW_DOCUMENT_DOCTOR_APPROVAL'
                            )
                        "
                        >Reason</CButton
                      >
                    </div>
                    <div class="my-3 mb-xl-0 contact-div d-flex">
                      <div>
                        <CDropdown
                          color="link"
                          size="lg"
                          :caret="false"
                          class="dropdowndocbox"
                        >
                          <template #toggler-content>
                            <verticalDotsSVG />
                          </template>
                          <CDropdownItem @click="getViewDetails(doctor)"
                            >View Details</CDropdownItem
                          >
                          <CDropdownItem>Call</CDropdownItem>
                          <CDropdownItem>Deactivate</CDropdownItem>
                          <CDropdownItem
                            @click="
                              goToChat(
                                doctor.doctor_id._id,
                                doctor.doctor_id.full_name
                              )
                            "
                            >Chat</CDropdownItem
                          >
                          <CDropdownItem
                            v-if="doctor.email != ''"
                            :href="`mailto:${doctor.email}`"
                            >Email</CDropdownItem
                          >
                        </CDropdown>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination
          v-if="doctors && doctors.length"
          class="mx-1 mob-t-center pagination-block"
          :recordPerPage="recordPerPage"
          :currentPage="currentPage"
          :total="total"
          @changePage="changePage"
        />
      </CCol>
    </CRow>
    <VerifyDoctorModal
      ref="VerifyDoctorModal"
      @refreshList="getDoctors"
      @showDoctorLogModal="showDoctorLogModal"
    />
    <DoctorLogModal
      ref="DoctorLogModal"
      @showVerifyModal="viewDoctorDocument"
    />
    <highest-qualification-modal
      v-if="showHighestQualifications"
      :showHighestQualifications="showHighestQualifications"
      :selectedQualifications="selectedQualifications"
      @close="showHighestQualifications = false"
    ></highest-qualification-modal>
    <CRow v-if="showDoctorProfile">
      <CCol sm="12" class="p-0">
        <doctor-profile-summary-details
          v-if="showDoctorProfile"
          @close="closeProfile()"
          :userId="userId"
        ></doctor-profile-summary-details>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import InfoIconSVG from "@/views/SVG/InfoIconSVG";
import config from "@/config.js";
const VerifyDoctorModal = () => import("./Modals/VerifyDoctorModal");
const DoctorLogModal = () => import("./Modals/DoctorLogModal");
import formats from "@/formats";
import moment from "moment";
import debounce from "lodash/debounce";
import { pickSvg } from "@/views/SVG";
import ChatMixin from "@/common/ChatMixin";
import { mapGetters } from "vuex";
const highestQualificationsModal = () =>
  import("@/components/modals/highestQualifications.vue");
export default {
  mixins: [ChatMixin],
  watch: {
    recordPerPage: function(val) {
      this.getSearchResult();
    },
    search: function(val) {
      this.getSearchResult();
    },
    status: function(val) {
      this.getSearchResult();
    },
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  data() {
    return {
      selectedQualifications: [],
      showHighestQualifications: false,
      exportLoading: false,
      verifyDoctorModal: false,
      viewLogModal: false,
      verifyDoctorReasonModal: false,
      approveConfirmation: false,
      GiveRejectReason: false,
      rejectApprove: true,
      doctors: [],
      search: "",
      recordPerPage: 10,
      status: "PENDING",
      currentPage: 1,
      totalPage: 0,
      perPageOptions: [10, 20, 30, 50, 100],
      statusOptions: [
        { value: "ALL", label: "All" },
        { value: "PENDING", label: "Pending" },
        { value: "APPROVED", label: "Approved" },
        { value: "REJECT", label: "Rejected" },
        { value: "NOT_UPLOADED", label: "Not Uploaded" },
      ],
      total: 0,
      showDoctorProfile: false,
      userId: "",
    };
  },
  components: {
    InfoIconSVG,
    VerifyDoctorModal,
    DoctorLogModal,
    doctorProfileSummaryDetails: () =>
      import("@/views/dashboardNew/userListing/doctorProfileSummaryDetails"),
    ...pickSvg("messageSVG", "phoneSVG", "emailSVG"),
    pagination: () => import("@/views/common/Pagination"),
    "highest-qualification-modal": highestQualificationsModal,
  },
  methods: {
    setHighestQualifications(qualifications) {
      this.selectedQualifications = qualifications;
      this.showHighestQualifications = true;
    },
    downloadCsv() {
      this.exportLoading = true;
      let url = `${config.BASE_URL}api/v2/admin/doctor-list/export`;
      let payload = {
        status: this.status,
        search_text: this.search,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          if (res.body.status) {
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(
              new Blob(["\ufeff", res.body.data.csvString])
            );
            downloadLink.download = "doctor-approval-list.csv";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    clearSearch() {
      this.search = "";
    },
    confirmationAppoval() {
      this.rejectApprove = false;
      this.approveConfirmation = true;
    },
    cancelApprovation() {
      this.rejectApprove = true;
      this.approveConfirmation = false;
    },
    rejectapproval() {
      this.GiveRejectReason = true;
      this.rejectApprove = false;
    },
    cancelRejectReason() {
      this.GiveRejectReason = false;
      this.rejectApprove = true;
    },
    getSearchResult: debounce(function(e) {
      this.doctors = [];
      this.currentPage = 1;
      this.getDoctors();
    }, 800),
    getDoctors() {
      let url = `${config.BASE_URL}api/v2/admin/doctor-list`;
      let payload = {
        status: this.status,
        search_text: this.search,
        page: this.currentPage,
        record_per_page: this.recordPerPage,
      };

      this.$http.post(url, payload).then((res) => {
        if (res.body.status) {
          this.doctors = res.body.data.list;
          for (let i in this.doctors) {
            this.doctors[i].doctor_id.highest_qualification = this.doctors[
              i
            ].doctor_id.highest_qualification.filter(
              (word) => word !== "Other"
            );
            if (this.doctors[i].doctor_id.other_qualification) {
              this.doctors[i].doctor_id.highest_qualification.push(
                this.doctors[i].doctor_id.other_qualification
              );
            }
          }
          this.totalPage = Math.ceil(
            res.body.data.total_count / this.recordPerPage
          );
          this.total = res.body.data.total_count;
        }
      });
    },
    verifyDoctor(doctor) {
      this.$refs.VerifyDoctorModal.viewModal(doctor);
    },
    showDoctorLogModal(data) {
      this.$refs.DoctorLogModal.viewModal(data.doctor);
    },
    viewDoctorDocument(data) {
      this.$refs.VerifyDoctorModal.viewModal(
        data.doctor,
        data.fromLog,
        data.doctorObj
      );
    },
    moment(dateAndTime) {
      return moment(dateAndTime).format(formats.date_time_format);
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.$router.replace({
        path: "/doctor-list",
        query: { page: this.currentPage },
      });
      this.getDoctors();
    },
    udpateRecordPerPage(perPage) {
      this.recordPerPage = perPage;
    },
    udpateStatus(status) {
      this.status = status;
    },
    checkRequestWasRejected(histories) {
      let truth = false;
      histories.forEach((history) => {
        if (history.current_document_status == "REJECT") {
          truth = true;
        }
      });
      return truth;
    },
    getViewDetails(doctor) {
      console.log("doctorDetails: ", doctor);
      this.userId = doctor.doctor_id._id;
      this.showDoctorProfile = true;
    },
    closeProfile() {
      this.showDoctorProfile = false;
    },
  },
  mounted() {
    this.currentPage = parseInt(
      this.$route.query.page ? this.$route.query.page : this.currentPage
    );
    this.getDoctors();
  },
};
</script>

<style>
.export-doctor-list {
  margin-top: 30px;
}
</style>
